const vi_VN = {
  "产品菜单": "Danh mục sản phẩm",
  "关于我们菜单": "Về chúng tôi",
  "帮助中心菜单": "Trung tâm hỗ trợ",
  "信用基础": "Lấy niềm tin làm nền tảng",
  "加密支付": "Thanh toán bằng tiền mã hóa",
  "全币种支持": "Hỗ trợ các loại tiền tệ kỹ thuật số",
  "全节点承兑": "Mạng lưới thanh toán toàn bộ node",
  "去中心担保": "Cơ chế bảo chứng phi tập trung",
  "立即开始使用": "Khởi động trải nghiệm ngay hôm nay",
  "闪电般的支付体验": "Trải nghiệm thanh toán nhanh như chớp",
  "完成跨境支付": "Hoàn tất giao dịch xuyên biên giới chỉ trong 45 giây",
  "多链支持": "Hỗ trợ đa chuỗi blockchain",
  "支持主流公链资产": "Tích hợp tài sản trên các blockchain hàng đầu",
  "实时结算": "Thanh toán và quyết toán theo thời gian thực",
  "无需等待": "Giao dịch hoàn tất trong vài giây không cần chờ đợi",
  "超额担保": "Bảo chứng vượt mức, an toàn tuyệt đối",
  "资金安全有保障": "An toàn tài sản được đảm bảo tuyệt đối",
  "一个钱包": "Một ví quản lý tất cả",
  "所有可能": "Mở ra mọi khả năng thanh toán",
  "商户收款": "Giải pháp thu hộ dành cho doanh nghiệp",
  "全球化支付网关": "Cổng thanh toán toàn cầu",
  "承兑服务": "Dịch vụ chấp nhận và xử lý thanh toán",
  "稳定可靠的承兑网络": "Mạng lưới thanh toán ổn định và đáng tin cậy",
  "数字资产": "Tài sản kỹ thuật số",
  "多链资产管理": "Giải pháp quản lý tài sản đa chuỗi",
  "下载": "Tải App",
  "多节点承兑": "Thanh toán đa Node",
  "生态": "Hệ sinh thái",
  "钱包": "Ví điện tử TEPAY",
  "立即下载": "Tải xuống ngay",
  "随时汇币": "Thanh toán mọi lúc, mọi nơi chuyển tiền quốc tế chưa bao giờ dễ dàng đến thế",
  "走天下": "Kết nối toàn cầu",
  "海量订单": "Lượng đơn hàng khổng lồ",
  "日进斗金": "Doanh thu dồi dào mỗi ngày",
  "轻松交易": "Giao dịch dễ dàng",
  "全球通用": "Sử dụng toàn cầu",
  "让每一笔支付": "Được hoàn tất tức thì",
  "瞬间达成": "Được hoàn tất tức thì",
  "护航每笔交易": "Bảo vệ mọi giao dịch",
  "去中心化担保": "Bảo chứng phi tập trung",
  "安全无忧": "An toàn không lo ngại",
  "slide4Text": "Thông qua cơ chế bảo chứng phi tập trung, mỗi giao dịch đều được đảm bảo về độ tin cậy và an toàn.",
  "一个钱包走天下": "Với chỉ một ví, sử dụng khắp thế giới",
  "币随时付": "Thanh toán bằng tiền mã hóa mọi lúc",
  "跨境无忧": "Thanh toán xuyên biên giới không lo ngại",
  "slide5Text": "Quản lý tất cả tài sản tại một nơi; dù là tiền pháp định hay tiền mã hóa, đều nằm trong một ví an toàn.",
  "边兑边赚": "Vừa đổi vừa sinh lời",
  "信用随行": "Tín dụng đồng hành",
  "slide7Text": "Mỗi lần hoán đổi đều giúp lợi nhuận tăng gấp bội, đồng thời điểm tín dụng tăng trưởng ổn định.",
  "开启信用支付": "Kích hoạt thanh toán tín dụng",
  "多币种支持": "Hỗ trợ đa tiền tệ",
  "多节点承兑描述": "Thanh toán đa Node",
  "下载Text": "Tải xuống",
  "链上赋能": "Trao quyền trên chuỗi",
  "品牌即社区": "Cộng đồng vững mạnh, thương hiệu bền lâu",
  "消费即投资": "Tiêu dùng cũng là đầu tư",
  "本地即全球": "Từ bản địa đến toàn cầu",
  "首页描述": "Nền tảng thương mại điện tử cộng đồng NECO được xây dựng trên khung niềm tin phi tập trung Web3, kết hợp sâu sắc giữa tiêu dùng thực tế và cơ chế hoàn trả minh bạch trên chuỗi. NECO tái định hình vòng tuần hoàn giá trị giữa người dùng, nhà bán hàng và cộng đồng, mở ra một mô hình thương mại điện tử mới – chia sẻ, đáng tin cậy và bền vững.",
  "真实消费": "Mua sắm thực tế",
  "支撑返利": "Hỗ trợ hoàn tiền",
  "slide2Text": "Mua sắm càng nhiều, Cashback càng cao",
  "slide2Info": "NECO chỉ phát hành trái phiếu và điểm thưởng sau khi đơn hàng được hoàn tất và được xác nhận trên blockchain. Mức hoàn trả được cố định nghiêm ngặt ở mức 20% ưu đãi từ nhà bán hàng, tuyệt đối không có phát hành vượt mức. Điều này có nghĩa là toàn bộ phần thưởng trên nền tảng đều được chi trả từ dòng tiền thật. Người dùng có thể dễ dàng tra cứu nguồn gốc của từng giao dịch NECO/USAI trên blockchain, loại bỏ hoàn toàn rủi ro từ các mô hình bất hợp pháp.",
  "透明积分": "Điểm thưởng minh bạch",
  "代币经济": "Kinh tế Token",
  "slide3Text": "Điểm on-chain, giá trị rõ ràng",
  "slide3Info1": "Cashback minh bạch: chia thành NECO token và stablecoin USAI",
  "slide3Info2": "Loại thứ nhất được giải phóng 0,2% mỗi ngày; loại thứ hai sẽ tự động cân bằng tỷ giá thông qua cơ chế đốt hoặc phát hành.",
  "slide3Info3": "Tất cả các sự kiện phát hành, đốt hoặc giải phóng đều được ghi lại. Bất kỳ ai cũng có thể theo dõi số dư ví, trả thưởng và lịch sử giao dịch, mỗi phần trả thưởng đều có một ID minh bạch.",
  "多角色": "Đa năng – Đa vai trò",
  "激励生态": "Hệ sinh thái khuyến khích người dùng",
  "slide4Text1": "Người dùng – Trưởng nhóm – Nhà bán hàng: cùng nhau xây dựng hệ sinh thái win-win.",
  "slide4Info1": "Người dùng được Cashback 100% khi mua sắm, đồng thời khi nắm giữ NECO sẽ được hưởng lợi từ tăng giá trị.",
  "slide4Info2": "Leader cộng đồng: Tổ chức mua chung – xây cộng đồng – nhận hoa hồng & thưởng NECO.",
  "slide4Info3": "Nhà bán hàng: Tăng đơn hàng chất lượng – 0% phí giao dịch – nâng tầm thương hiệu.",
  "slide4Info4": "Ba bên cùng hưởng lợi – Minh bạch trên Blockchain – Tăng trưởng tự động.",
  "合规保障": "Tuân thủ pháp lý – An toàn và minh bạch",
  "全程可审": "Quy trình minh bạch, dễ kiểm chứng",
  "slide5Text": "Truy xuất tức thì, minh bạch và hợp pháp.",
  "slide5Info1": "Cổng thanh toán TePay có KYC (xác minh danh tính), kết nối với tiền pháp định và đảm bảo tuân thủ quy định. Tất cả dữ liệu giao dịch, đều được lưu trữ minh bạch trên Blockchain.",
  "slide5Info2": "Nền tảng được trang bị cơ chế kép oracle, vùng đệm giá và quỹ DAO quản trị rủi ro. Khi thị trường biến động mạnh hoặc có thay đổi chính sách, cộng đồng có thể kích hoạt giới hạn tốc độ, cơ chế mua lại hoặc tạm dừng thông qua bỏ phiếu quản trị giúp cơ quan quản lý yên tâm, người dùng an toàn, hệ sinh thái bền vững.",
  "合作伙伴": "Đối tác",
  "社区团购": "Cộng đồng mua chung",
  "社区小店": "Cửa hàng cộng đồng",
  "社区空间": "Không gian cộng đồng",
  "社区服务": "Dịch vụ cộng đồng",
  "NECO优选": "NECO chọn",
  "暂未开放": "Tạm thời chưa mở",
  "新闻标题": "Tin tức",
  "返回": "Quay lại",
  "消费返股": "Mua sắm được Cashback",
  "全球首个": "Đầu tiên trên thế giới",
  "WEB3社区电商平台": "Nền tảng TMĐT cộng đồng Web3",
  "消费": "Mua sắm",
  "赚钱": "Kiếm tiền",
  "持股": "Nắm cổ phần",
  "合伙人": "Người mua Node",
  "用户": "Người dùng",
  "股东": "Cổ đông",
  "不只是电商": "NECO không chỉ là sản TMĐT",
  "更是社区电商": "Hơn thế nữa, NECO là thương mại điện tử cộng đồng.",
  "共赢闭环": "Người dùng – Trưởng nhóm – Nhà bán hàng: cùng nhau xây dựng hệ sinh thái win-win.",
  "用户描述": "Người dùng được Cashback 100% khi mua sắm, đồng thời khi nắm giữ NECO sẽ được hưởng lợi từ tăng giá trị.",
  "团长描述": "Leader cộng đồng: Tổ chức mua chung – xây cộng đồng – nhận hoa hồng & thưởng NECO.",
  "商户描述": "Nhà bán hàng: Tăng đơn hàng chất lượng – 0% phí giao dịch – nâng tầm thương hiệu.",
  "三方描述": "Ba bên cùng hưởng lợi – Minh bạch trên Blockchain – Tăng trưởng tự động.",
  "购物聊天": "Thương mại điện tử NECO AI – giúp việc mua sắm trở nên đơn giản như trò chuyện.",
  "边聊边选": "Chat liền tay, chọn ngay hàng",
  "聊天助手实时理解你的对话": "Trợ lý AI hiểu bạn muốn gì",
  "就能找到你要的东西": "Một câu thôi, bạn sẽ tìm được món đồ mà mình muốn",
  "AI优选": "AI chọn",
  "的那一刻": "Khoảnh khắc bạn mở NECO lên",
  "已经在等你": "Mọi sản phẩm & dịch vụ phù hợp nhất đều đang chờ bạn khám phá.",
  "时尚分身": "Thời trang",
  "监控价格": "Tìm sản phẩm tốt, theo giá",
  "守护你的消费体验": "Bảo vệ trải nghiệm mua sắm của bạn",
  "三类团购机制": "Ba hình thức mua theo nhóm",
  "附近团": "Nhóm gần bạn",
  "熟人团": "Nhóm người quen",
  "优选团": "Nhóm chọn ưu tiên",
  "全球战略布局": "Chiến lược toàn cầu",
  "使命与愿景": "Sứ mệnh & Tầm nhìn của NECO",
  "使命": "Sứ mệnh",
  "愿景": "Tầm nhìn",
  "使命描述": "Xây dựng hệ thống công bằng, minh bạch và ai cũng có thể tham gia",
  "愿景描述": "Lan tỏa ánh sáng kinh tế cộng đồng đến mọi nơi.",
  "公告": "Thông báo",
  "铸造销毁协议": "Giao thức đúc và hủy",
  "SWAP交易": "Giao dịch SWAP",
  "NECO社区电商": "TMĐT cộng đồng NECO",
  "菜单": "Danh mục",
  "安卓下载": "Tải xuống Android",
  "ios下载": "Tải xuống iOS",
  "NECO下载": "Tải Ứng dụng NECO",
  "支持版本": "Hỗ trợ phiên bản IOS và Android",
  "当前版本": "Phiên bản hiện tại",
  "跨链桥": "Cầu Liên chuỗi",
  "合作伙伴关系": "Quan hệ đối tác",
  "请加入社交媒体信息": "Vui lòng tham gia thông tin truyền thông xã hộiq",
  "联系我们": "Liên hệ chúng tôi",
  "版权所有（公司）": "Bản quyền (Công ty)",
  "联系我们的邮件请填写": "Email liên hệ Vui lòng điền",
  "新闻": "tin tức",
  "网页直连": "Trực tiếp đến trang web",
  "铸造与销毁协议": "Thỏa thuận đúc và tiêu hủy",
  "更多": "thêm nữa",
  "请通过": "Vui lòng pass",
  "与我们联系": "Kết nối với chúng tôi",
  "版权所有": "Tất cả các quyền",
  "联系": "liên hệ",
  "智能体": "Trang chủ",

  
  "全球首个": "Toàn cầu đầu tiên",
  "WEB3社区电商平台": "Nền tảng thương mại điện tử cộng đồng WEB3",
  "消费": "Tiêu dùng",
  "持股": "Cổ phần",
  "升值": "Tăng giá",
  "重新定义消费的价值": "Định nghĩa lại giá trị tiêu dùng",
  "让消费成为财富的起点": "Biến tiêu dùng thành điểm khởi đầu của sự giàu có",
  "消费即拥有，分享即收益": "Tiêu dùng tức là sở hữu, chia sẻ tức là thu nhập",
  "NECO 是一套基于 Web3 技术的智能电商基础设施，通过「消费即持股」机制，让每一位用户在购物时获得真实权益与长期回报。 在这里，消费者不只是用户，更是平台的拥有者和生态的建设者。": "NECO là một cơ sở hạ tầng thương mại điện tử thông minh dựa trên công nghệ Web3, thông qua cơ chế \"tiêu dùng tức cổ phần\", giúp mỗi người dùng nhận được quyền lợi thực tế và lợi nhuận dài hạn khi mua sắm. Ở đây, người tiêu dùng không chỉ là người dùng mà còn là chủ sở hữu nền tảng và người xây dựng hệ sinh thái.",
  "核心技术": "Công nghệ cốt lõi",
  "基于 Novai Chain 的二层网络": "Mạng lưới tầng hai dựa trên Novai Chain",
  "Neco Chain 是构建在 Novai Chain 之上的高性能二层网络，": "Neco Chain là mạng lưới tầng hai hiệu suất cao được xây dựng trên Novai Chain,",
  "专为高频电商与支付结算设计，平均出块时间仅 0.2 秒，TPS 超过 50,000。": "Được thiết kế đặc biệt cho thương mại điện tử tần suất cao và thanh toán kết toán, thời gian tạo khối trung bình chỉ 0,2 giây, TPS vượt quá 50.000.",
  "Neco Chain 将电商的每笔消费行为与激励记录上链，": "Neco Chain ghi lại chuỗi mỗi hành vi tiêu dùng và khuyến khích trong thương mại điện tử,",
  "让商业行为具备长期可验证性与可追溯性。": "Làm cho các hành vi thương mại có khả năng xác minh và truy xuất nguồn gốc dài hạn.",
  "高速并行账本结构": "Cấu trúc sổ cái song song tốc độ cao",
  "智能结算与动态费用调节": "Kết toán thông minh và điều chỉnh phí động",
  "消费凭证 NFT 化与积分资产化": "Chứng nhận tiêu dùng NFT hóa và tích phân tài sản hóa",
  "核心特性": "Đặc tính cốt lõi",
  "链上结算": "Kết toán trên chuỗi",
  "每笔电商交易 0.2 秒确认，安全透明": "Mỗi giao dịch thương mại điện tử xác nhận trong 0,2 giây, an toàn minh bạch",
  "激励协议": "Giao thức khuyến khích",
  "激励消费者、商家、渠道等为NECO做出贡献": "Khuyến khích người tiêu dùng, nhà bán hàng, kênh phân phối đóng góp cho NECO",
  "权益积分": "Tích phân quyền lợi",
  "用户消费即持有可追踪、可变现的权益积分": "Người dùng tiêu dùng tức nắm giữ tích phân quyền lợi có thể theo dõi và chuyển đổi",
  "共建共享": "Cùng xây dựng cùng chia sẻ",
  "首个去中心商业自治组织，共建共享NECO电商": "Tổ chức tự trị thương mại phi tập trung đầu tiên, cùng xây dựng chia sẻ thương mại điện tử NECO",
  "主要产品": "Sản phẩm chính",
  "支持电商 RWA 的高性能公链": "Chuỗi công cộng hiệu suất cao hỗ trợ RWA thương mại điện tử",
  "稳定币、DEX、去中心信用等电商基础协议": "Đồng ổn định, DEX, tín dụng phi tập trung và các giao thức cơ bản thương mại điện tử",
  "同时为WEB2和WEB3用户服务的电商APP": "Ứng dụng thương mại điện tử phục vụ đồng thời người dùng WEB2 và WEB3",
  "法币和数字货币统一支付及结算体系": "Hệ thống thanh toán và kết toán thống nhất tiền pháp định và tiền số",
  "竞争优势": "Lợi thế cạnh tranh",
  "极速公链": "Chuỗi công cộng tốc độ cực nhanh",
  "0.2 秒出块，支持百万级并发订单及支付交易。": "0,2 giây ra khối, hỗ trợ hàng triệu đơn hàng và giao dịch thanh toán đồng thời.",
  "全球合规": "Tuân thủ toàn cầu",
  "在全球各地通过 DAO 组织进行本地合规运营。": "Vận hành tuân thủ địa phương thông qua tổ chức DAO trên toàn thế giới.",
  "电商 RWA": "RWA thương mại điện tử",
  "第一个将现实世界电商完全放在链上运行的平台。": "Nền tảng đầu tiên đưa hoàn toàn thương mại điện tử thế giới thực chạy trên chuỗi.",
  "商业闭环": "Vòng khép kín thương mại",
  "让消费、社交与收益形成价值闭环。": "Làm cho tiêu dùng, mạng xã hội và thu nhập tạo thành vòng khép kín giá trị.",
  "全球分销体系让每个用户都能成为品牌的传播者与收益方。": "Hệ thống phân phối toàn cầu giúp mỗi người dùng trở thành người truyền bá thương hiệu và bên hưởng lợi.",
  "消费者端": "Phía người tiêu dùng",
  "注册/消费即得积分奖励，积分每日释放为资产。": "Đăng ký/tiêu dùng tức nhận thưởng tích phân, tích phân giải phóng hàng ngày thành tài sản.",
  "商家端": "Phía nhà bán hàng",
  "一键接入结算 API，设置折让比例与积分政策。": "Một cú nhấp kết nối API kết toán, thiết lập tỷ lệ chiết khấu và chính sách tích phân.",
  "分销端": "Phía phân phối",
  "允许全球用户参与分销，共享收益与品牌成长。": "Cho phép người dùng toàn cầu tham gia phân phối, chia sẻ thu nhập và phát triển thương hiệu.",
  "NECO 生态系统": "Hệ sinh thái NECO",
  "一个融合金融、科技与商业的去中心化生态。": "Một hệ sinh thái phi tập trung kết hợp tài chính, công nghệ và thương mại.",
  "Neco Chain 公链": "Chuỗi công cộng Neco Chain",
  "商业级高速 Layer 2 网络（Novai L2），提供结算与数据验证基础设施。": "Mạng Layer 2 tốc độ cao cấp thương mại (Novai L2), cung cấp cơ sở hạ tầng kết toán và xác minh dữ liệu.",
  "NECO App": "Ứng dụng NECO",
  "用户购物、签到、邀请与分销的统一入口。": "Cổng vào thống nhất cho mua sắm, điểm danh, mời và phân phối của người dùng.",
  "USAI 稳定币": "Đồng ổn định USAI",
  "用于平台内支付与结算的稳定币资产，锚定美元价值。": "Tài sản đồng ổn định dùng cho thanh toán và kết toán trong nền tảng, neo giá trị đô la Mỹ.",
  "U Card 全球消费卡": "Thẻ tiêu dùng toàn cầu U Card",
  "连接线上线下消费场景，支持积分抵扣与现金返还。": "Kết nối các tình huống tiêu dùng trực tuyến và ngoại tuyến, hỗ trợ khấu trừ tích phân và hoàn tiền mặt.",
  "NECO AI 智能系统": "Hệ thống thông minh NECO AI",
  "通过 AI 分析用户行为，实现个性化推荐与安全风控。": "Thông qua AI phân tích hành vi người dùng, thực hiện đề xuất cá nhân hóa và kiểm soát rủi ro an toàn.",
  "消费金融该协议": "Giao thức tài chính tiêu dùng",
  "提供通用的去中心化金融基础设施，支持电商资产流通。": "Cung cấp cơ sở hạ tầng tài chính phi tập trung phổ dụng, hỗ trợ lưu thông tài sản thương mại điện tử.",
  "稳定币生态": "Hệ sinh thái đồng ổn định",
  "构建覆盖支付、结算与跨境流通的稳定币网络。": "Xây dựng mạng lưới đồng ổn định bao phủ thanh toán, kết toán và lưu thông xuyên biên giới.",
  "团队及投资人": "Đội ngũ và nhà đầu tư",
  "全球化视野 · 多元化背景。": "Tầm nhìn toàn cầu · Bối cảnh đa dạng.",
  "NECO 团队成员来自新加坡、中国、阿联酋等地，拥有电商、金融科技与区块链技术领域超过十年的行业经验。": "Thành viên đội ngũ NECO đến từ Singapore, Trung Quốc, UAE và các nơi khác, có hơn mười năm kinh nghiệm ngành trong lĩnh vực thương mại điện tử, công nghệ tài chính và công nghệ chuỗi khối.",
  "投资人": "Nhà đầu tư",
  "运营团队": "Đội ngũ vận hành",
  "Moe Farmani": "Moe Farmani",
  "拥有多年欧洲、中东、南美零售企业创业经验,曾创建迪拜领先的数字货币交易所 加密货币的重度信仰者": "Có nhiều năm kinh nghiệm khởi nghiệp doanh nghiệp bán lẻ châu Âu, Trung Đông, Nam Mỹ, từng thành lập sàn giao dịch tiền số hàng đầu Dubai, tín đồ nặng công nghệ tiền mã hóa",
  "Matt Romman": "Matt Romman",
  "从事迪拜房地产和零售行业多年。拥有丰富的跨国公司管理经验。": "Làm trong ngành bất động sản và bán lẻ Dubai nhiều năm. Có kinh nghiệm quản lý công ty đa quốc gia phong phú.",
  "Alex Eric": "Alex Eric",
  "曾任职OKX，负责公司品牌和战略": "Từng làm việc tại OKX, phụ trách thương hiệu và chiến lược công ty",
  "Manoharlal": "Manoharlal",
  "Novai Chain Founder， 全面支撑NECO技术落地。": "Nhà sáng lập Novai Chain, toàn diện hỗ trợ triển khai công nghệ NECO.",
  "官方路线图": "Lộ trình chính thức",
  "2025 — 创世与启动": "2025 — Sáng thế và khởi động",
  "2025 — 增长与市场拓展": "2025 — Tăng trưởng và mở rộng thị trường",
  "2026 — 生态深化与 AI 赋能": "2026 — Đào sâu hệ sinh thái và trao quyền AI",
  "上半年（Q2–Q3）": "Nửa đầu năm (Q2–Q3)",
  "完成白皮书、制度模型与产品原型开发": "Hoàn thành phát triển sách trắng, mô hình chế độ và nguyên mẫu sản phẩm",
  "组织九大社区进行创世启动": "Tổ chức chín cộng đồng tiến hành khởi động sáng thế",
  "完成 300 个节点招募，发行 NECO & USAI 代币，添加初始流动性池": "Hoàn thành tuyển dụng 300 nút, phát hành token NECO & USAI, thêm nhóm thanh khoản ban đầu",
  "发布 NECO APP BETA 测试版": "Phát hành phiên bản thử nghiệm BETA ứng dụng NECO",
  "下半年（Q3–Q4）": "Nửa sau năm (Q3–Q4)",
  "全球社区运营中心部署完成": "Triển khai hoàn thành trung tâm vận hành cộng đồng toàn cầu",
  "NECO 优选店铺与创世商户上线": "Cửa hàng ưu tú NECO và nhà bán hàng sáng thế ra mắt",
  "推动注册用户突破 10 万": "Thúc đẩy người dùng đăng ký vượt qua 100.000",
  "启动空投及全球电商启动大会": "Khởi động airdrop và hội nghị khởi động thương mại điện tử toàn cầu",
  "Q4：好货推广 & 本地电商": "Q4: Quảng bá hàng tốt & Thương mại điện tử địa phương",
  "上线「好货系统」并开放会员商家入驻": "Ra mắt \"hệ thống hàng tốt\" và mở cửa nhập cư cho nhà bán hàng thành viên",
  "在主要国家开通 TePay 法币支付": "Mở thông thanh toán tiền pháp định TePay tại các nước chính",
  "完成中国、韩国、越南 10 家 NECO Best 本地电商落地": "Hoàn thành triển khai 10 nền tảng thương mại điện tử địa phương NECO Best tại Trung Quốc, Hàn Quốc, Việt Nam",
  "海外注册用户突破 50 万，VIP 用户突破 5 万": "Người dùng đăng ký hải ngoại vượt qua 500.000, người dùng VIP vượt qua 50.000",
  "举办第二次社区电商大会，开放跨境卖家注册": "Tổ chức hội nghị thương mại điện tử cộng đồng lần thứ hai, mở đăng ký người bán xuyên biên giới",
  "拓展中东、南美、非洲与欧洲本地市场，整合供应链": "Mở rộng thị trường địa phương Trung Đông, Nam Mỹ, châu Phi và châu Âu, tích hợp chuỗi cung ứng",
  "注册用户突破 100 万，VIP 用户突破 10 万": "Người dùng đăng ký vượt qua 1 triệu, người dùng VIP vượt qua 100.000",
  "Q1–Q2：体系完善": "Q1–Q2: Hoàn thiện hệ thống",
  "跨境卖家突破 10 万，商家数量超 10 万": "Người bán xuyên biên giới vượt qua 100.000, số lượng nhà bán hàng vượt 100.000",
  "举办第一届 NECO 电商生态大会": "Tổ chức hội nghị hệ sinh thái thương mại điện tử NECO lần thứ nhất",
  "上线稳定币生态与信用体系": "Ra mắt hệ sinh thái đồng ổn định và hệ thống tín dụng",
  "注册用户突破 500 万，VIP 超过 20 万": "Người dùng đăng ký vượt qua 5 triệu, VIP vượt quá 200.000",
  "Q3–Q4：智能升级": "Q3–Q4: Nâng cấp thông minh",
  "获得主要国家支付牌照，全面上线法币支付服务": "Nhận được giấy phép thanh toán các nước chính, toàn diện ra mắt dịch vụ thanh toán tiền pháp định",
  "上线 AI 选品与推荐功能": "Ra mắt chức năng chọn sản phẩm và đề xuất AI",
  "商家信用、积分全面上链": "Tín dụng nhà bán hàng, tích phân toàn diện lên chuỗi",
  "NECO Best 优选商家突破 100 家": "Nhà bán hàng ưu tú NECO Best vượt qua 100",
  "注册用户突破 1000 万，VIP 超过 50 万": "Người dùng đăng ký vượt qua 10 triệu, VIP vượt quá 500.000",
  "加入 NECO": "Tham gia NECO",
  "消费创造财富，社区共建共享。": "Tiêu dùng tạo ra của cải, cộng đồng cùng xây dựng và chia sẻ.",
  "一分钟带你了解NECO": "Một phút nữa tôi sẽ đưa bạn đến với NECO",
  "NECO 通过链上透明的返利机制，让每一次消费都能获得真实收益。": "NECO mang lại lợi ích thực sự cho mọi chi tiêu thông qua cơ chế hoàn vốn minh bạch trên chuỗi.",
  "相比传统电商，NECO 的利润由智能合约按比例即时返还，0 抽佣、0 压货。": "So với thương mại điện tử truyền thống, lợi nhuận của NECO được trả lại ngay lập tức bằng hợp đồng thông minh, 0 hoa hồng, 0 áp lực.",
  "用户与商家共享增长红利。": "Người dùng chia sẻ cổ tức tăng trưởng với người bán.",
  "全球版": "Hệ thống toàn cầu",
  "中国版": "Hệ thống Trung Quốc",

}
export default vi_VN



// WEBPACK FOOTER //
// ./src/i18n/config/vi_VN.js